// $(function(){
//     $(document).ready(function() {
//         $(".banner").each(function() {
//             var thisElement = $(this);
//             thisElement.slick({
//                 fade: true,
//                 dots: true,
//                 infinite: true,
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//                 mobileFirst: true,
//                 arrows: false,
//                 responsive: [
//                     {
//                         breakpoint:992,
//                         settings: {
//                             slidesToShow: 1
//                         }
//                     },
//                 ]
//             });
//         })
//     });
// });